<template>
    <aside class="main-sidebar" ref="SidebarMenu" id="main_sidebar">
        <el-menu ref="menu" :router="true" class="sidebar-nav" :default-active="activeLink"
            :default-openeds="openedMenus" @open="onOpen" @close="onClose">
            <perfect-scrollbar :style="{height: height + 'px'}">
                <li v-if="isImpersonating" class="el-menu-item" @click.prevent="leaveImpersonation"
                    style="padding-left: 20px; color:#E6A23C;">
                    <i class="el-icon-refresh-left"></i>
                    <span class="sidebar-nav__link-text">Вернуться к {{ backCaption }}</span>
                </li>

                <el-menu-item index="/profile">
                    <i class="el-icon-user"></i>
                    <span class="sidebar-nav__link-text">Мой аккаунт</span>
                </el-menu-item>

                <el-submenu index="2" v-if="canSeeGeneral">
                    <template #title>
                        <i class="el-icon-data-line"></i>
                        <span>Продвижение</span>
                    </template>
                    <el-menu-item index="/projects/quick-start" class="cta-item">
                        <i class="el-icon-plus"></i>
                        <span class="sidebar-nav__link-text">Создать проект</span>
                    </el-menu-item>
                    <el-menu-item index="/projects/list">
                        <i class="el-icon-aim"></i>
                        <span class="sidebar-nav__link-text">Проекты</span>
                    </el-menu-item>

                    <el-menu-item index="/project-groups/list">
                        <i class="el-icon-s-operation"></i>
                        <span class="sidebar-nav__link-text">Группы проектов</span>
                    </el-menu-item>

                    <el-menu-item index="/saas-queue">
                        <i class="el-icon-files"></i>
                        <span class="sidebar-nav__link-text">SaaS очередь</span>
                        <el-badge v-if="saasQueueCount > 0" :value="saasQueueCount" class="badge"
                            style="margin-left: 8px;" />
                    </el-menu-item>

                    <li class="el-menu-item" style="padding-left: 40px;" @click.prevent="copyUpdateStatisticUrl"
                        v-if="ibotEnabled">
                        <i class="el-icon-copy-document"></i>
                        <span class="sidebar-nav__link-text">URL для статистики</span>
                    </li>
                </el-submenu>

                <el-submenu index="1" v-if="canSeeGeneral">
                    <template #title>
                        <i class="el-icon-data-analysis"></i>
                        <span>Мониторинг</span>
                    </template>
                    <el-menu-item index="/i-bot-statistic" v-if="ibotEnabled">
                        <i class="el-icon-cpu"></i>
                        <span class="sidebar-nav__link-text">Копии iBot</span>
                    </el-menu-item>

                    <el-menu-item index="/services/list">
                        <i class="el-icon-setting"></i>
                        <span class="sidebar-nav__link-text">Сервисы</span>
                    </el-menu-item>
                </el-submenu>

                <el-submenu index="6" v-if="referral_token && canSeeGeneral">
                    <template #title>
                        <i class="el-icon-share"></i>
                        <span>Партнёрская программа</span>
                    </template>

                    <el-menu-item index="/referral/program">
                        <i class="el-icon-s-promotion"></i>
                        <span class="sidebar-nav__link-text">Виджет и статистика</span>
                    </el-menu-item>

                    <li class="el-menu-item" style="padding-left: 40px;" @click.prevent="copyRefUrl">
                        <i class="el-icon-copy-document"></i>
                        <span class="sidebar-nav__link-text">Скопировать реф. ссылку</span>
                    </li>
                </el-submenu>

                <el-submenu index="3" v-if="canSeeGeneral">
                    <template #title>
                        <i class="el-icon-help"></i>
                        <span>Помощь</span>
                    </template>
                    <el-menu-item index="/help/consumption" v-if="ibotEnabled">
                        <i class="el-icon-shopping-cart-2"></i>
                        <span class="sidebar-nav__link-text">Расходка</span>
                    </el-menu-item>

                    <el-menu-item index="/help/docs" v-if="ibotEnabled">
                        <i class="el-icon-reading"></i>
                        <span class="sidebar-nav__link-text">Документация</span>
                    </el-menu-item>

                    <el-menu-item index="/tickets">
                        <i class="el-icon-service"></i>
                        <span class="sidebar-nav__link-text">Техподдержка</span>
                    </el-menu-item>

                    <el-menu-item index="/contacts"><i class="el-icon-message"></i>
                        <span class="sidebar-nav__link-text">Контакты</span>
                    </el-menu-item>
                </el-submenu>

                <el-submenu index="4" v-if="canSeePumpOnly">
                    <template #title>
                        <i class="el-icon-collection"></i>
                        <span>Базы для прокачки</span>
                    </template>

                    <el-menu-item index="/pump/projects"><i class="el-icon-s-claim"></i>
                        <span class="sidebar-nav__link-text">Текущий тариф</span>
                    </el-menu-item>

                    <el-menu-item index="/pump/projects/settings"><i class="el-icon-setting"></i>
                        <span class="sidebar-nav__link-text">Настройки баз</span>
                    </el-menu-item>

                    <el-menu-item index="/pump/projects/statistics"><i class="el-icon-s-data"></i>
                        <span class="sidebar-nav__link-text">Статистика</span>
                    </el-menu-item>

                    <el-menu-item index="/pump/projects/tariffs"><i class="el-icon-s-order"></i>
                        <span class="sidebar-nav__link-text">Тарифы</span>
                    </el-menu-item>
                </el-submenu>

                <el-submenu index="5" v-if="canSeeAdminMenu">
                    <template #title>
                        <i class="el-icon-setting"></i>
                        <span>Администратор</span>
                    </template>

                    <!-- Пользователи -->
                    <el-menu-item index="/users" v-if="canSeeFullAdminItems">
                        <i class="el-icon-s-custom"></i>
                        <span class="sidebar-nav__link-text">Пользователи</span>
                    </el-menu-item>

                    <!-- Платежи -->
                    <el-menu-item index="/payments" v-if="canSeePayments">
                        <i class="el-icon-postcard"></i>
                        <span class="sidebar-nav__link-text">Платежи</span>
                    </el-menu-item>

                    <!-- Телеграм уведомления -->
                    <el-menu-item index="/telegram-notifications/list" v-if="canSeeFullAdminItems">
                        <i class="el-icon-chat-line-round"></i>
                        <span class="sidebar-nav__link-text">Телеграм уведомления</span>
                    </el-menu-item>

                    <!-- Saas -->
                    <el-menu-item index="/saas" v-if="canSeeFullAdminItems">
                        <i class="el-icon-files"></i>
                        <span class="sidebar-nav__link-text">Saas</span>
                    </el-menu-item>

                    <!-- Настройки -->
                    <el-menu-item index="/settings" v-if="canSeeFullAdminItems">
                        <i class="el-icon-setting"></i>
                        <span class="sidebar-nav__link-text">Настройки</span>
                    </el-menu-item>
                </el-submenu>
            </perfect-scrollbar>
        </el-menu>

        <input type="hidden" id="update_statistic_url" :value="updateStatisticUrl">
        <input type="hidden" id="ref_url" :value="refUrl">
    </aside>
</template>
<script>

import checkPermission from '@/admin/js/utils/permission';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import {mapGetters} from "vuex";

export default {
    components: { PerfectScrollbar },
    data(){
        return{
            height:0,
            updateStatisticUrl: '',
            refUrl: "",
            activeLink: null,
            menu:[],
            saasQueueCount: 0,
            openedMenus: [],
            ro: null,
        }
    },
    created() {
        this.restoreOpenedMenus();
    },
    mounted() {
        this.$nextTick(() => this.matchHeight());
        if (this.$refs.SidebarMenu) {
            this.ro = new ResizeObserver(() => {
                this.matchHeight();
            });
            this.ro.observe(this.$refs.SidebarMenu);
        }
        const matched = this.$route.matched || [];
        const match = _.chain(matched).sortBy(n => (n.path || '').length).last().value();
        const active =
            this.$route.meta?.activeMenu ||
            match?.path ||
            this.$route.path;

        this.activeLink = active;
        this.syncOpenedMenus();
        this.initSaasQueueCounter();
    },
    beforeDestroy() {
        if (this.ro) {
            try { this.ro.disconnect(); } catch { }
            this.ro = null;
        }
    },
    computed: {
        ...mapGetters([
            'referral_token',
            'impersonating',
            'impersonator_name',
            'roles',
            'permissions',
            'ibot_settings_enabled',
        ]),
        isImpersonating() { return !!this.impersonating; },
        backCaption() { return this.impersonator_name || 'администратору'; },

        isAdmin() { return Array.isArray(this.roles) && this.roles.includes('admin'); },
        isManager() { return Array.isArray(this.roles) && this.roles.includes('manager'); },
        isTester() { return Array.isArray(this.roles) && this.roles.includes('tester'); },
        isDeveloper() { return Array.isArray(this.roles) && this.roles.includes('developer'); },
        isAccountant() { return Array.isArray(this.roles) && this.roles.includes('accountant'); },
        // кто видит «Мониторинг», «Продвижение», «Базы для прокачки»
        canSeeGeneral() {
            return this.isAdmin || this.isDeveloper || this.isTester || this.isManager;
        },
        // кому показывать раздел «Администратор»
        canSeeAdminMenu() {
            // админ/дев/тестер — весь раздел; бухгалтер — только чтобы показать «Платежи»
            return this.isAdmin || this.isDeveloper || this.isTester || this.isAccountant;
        },
        // кто видит ВСЕ пункты внутри «Администратор», кроме платежей
        canSeeFullAdminItems() {
            return this.isAdmin || this.isDeveloper || this.isTester;
        },
        // кто видит «Платежи»
        canSeePayments() {
            return this.isAdmin || this.isDeveloper || this.isTester || this.isAccountant;
        },
        canSeePumpOnly() {
            return this.isAdmin || this.isTester;
        },
        ibotEnabled() {
            return !!this.ibot_settings_enabled;
        },
    },
    methods: {
        async leaveImpersonation() {
            try {
                await axios.post('/api/admin/impersonate/leave');
                if (this.$store?.dispatch) {
                    await this.$store.dispatch('user/getInfo').catch(() => { });
                }
                this.$message.success('Возвращаю вас к админ-аккаунту…');
                this.$router.replace('/users');
            } catch (e) {
                const msg = e?.response?.data?.message || 'Не удалось вернуться';
                this.$message.error(msg);
            }
        },
        openedKey() {
            const uid = this.$store?.getters?.userId || 'anon';
            return `sidebar.opened.v1.user.${uid}`;
        },
        restoreOpenedMenus() {
            try {
                const raw = localStorage.getItem(this.openedKey());
                const arr = JSON.parse(raw || '[]');
                this.openedMenus = Array.isArray(arr) ? arr.filter(x => typeof x === 'string') : [];
            } catch {
                this.openedMenus = [];
            }
        },
        persistOpenedMenus() {
            try { localStorage.setItem(this.openedKey(), JSON.stringify(this.openedMenus)); } catch { }
        },
        // Открыть сохранённые пункты после монтирования
        syncOpenedMenus() {
            this.$nextTick(() => {
                const menu = this.$refs.menu;
                if (menu && typeof menu.open === 'function') {
                    this.openedMenus.forEach(idx => menu.open(idx));
                }
            });
        },
        onOpen(index) {
            if (!this.openedMenus.includes(index)) {
                this.openedMenus = [...this.openedMenus, index];
                this.persistOpenedMenus();
            }
        },
        onClose(index) {
            if (this.openedMenus.includes(index)) {
                this.openedMenus = this.openedMenus.filter(i => i !== index);
                this.persistOpenedMenus();
            }
        },
        async initSaasQueueCounter() {
            try {
                // 1) Подгружаем текущее значение
                const { data } = await axios.get('/api/admin/saas-tasks/unread-count');
                this.saasQueueCount = data.count;
            } catch (err) {
                console.error('Не удалось получить количество задач:', err);
            }

            // 2) Подписываемся на приватный канал текущего пользователя
            const userId = this.$store.getters.userId;
            window.Echo.private(`user.${userId}`)
                .listen('.saas-task.created', e => {
                    this.saasQueueCount += e.count;
                })
                .listen('.saas-queue.delta', e => {
                    this.saasQueueCount = Math.max(0, this.saasQueueCount + (e.delta || 0));
                });
        },
        checkPermission,
        copyUpdateStatisticUrl() {
            const url = window.location.protocol + '//' + window.location.host + '/api/update-task/?tid=[[TID]]&taskid=[[TASKID]]&date=[[FORMATTED_DATE]]&tasktype=[[TASKTYPE]]&targetdomain=[[TARGETDOMAIN]]&targeturl=[[TARGETURL]]&keyword=[[KEYWORD]]&position=[[POSITION]]&getparameters=[[GETPARAMETERS]]&projectname=[[PROJECTNAME]]&pid=[[PID]]&device=[[DEVICE]]&cookies=[[COOKIES]]&uniquedomains=[[UNIQUEDOMAINS]]&ymdomains=[[YMDOMAINS]]&gadomains=[[GADOMAINS]]&proxy=[[PROXY]]';
            let updateStatisticUrlInput = document.querySelector('#update_statistic_url');
            updateStatisticUrlInput.setAttribute('type', 'text');
            updateStatisticUrlInput.setAttribute('value', url);
            updateStatisticUrlInput.select()

            try {
                var successful = document.execCommand('copy');
                var msg = successful ? 'successful' : 'unsuccessful';
                this.$message({
                    type: 'success',
                    message: 'Ссылка для отправки статистики из скрипта в API скопирована'
                });
            } catch (err) {

            }

            updateStatisticUrlInput.setAttribute('type', 'hidden')
            window.getSelection().removeAllRanges()
        },
        copyRefUrl() {
            const url = 'https://t.me/TOP_iBot?start=' + this.referral_token
            let refUrlInput = document.querySelector('#ref_url');
            refUrlInput.setAttribute('type', 'text');
            refUrlInput.setAttribute('value', url);
            refUrlInput.select()

            try {
                var successful = document.execCommand('copy');
                var msg = successful ? 'successful' : 'unsuccessful';
                this.$message({
                    type: 'success',
                    message: 'Реферальная ссылка скопирована'
                });
            } catch (err) {

            }

            refUrlInput.setAttribute('type', 'hidden')
            window.getSelection().removeAllRanges()
        },
        matchHeight() {
            const el = this.$refs.SidebarMenu;
            if (!el) return;
            const h = el.clientHeight || 0;
            this.height = Math.max(0, h - 80);
        },

    },
}
</script>
<style>
@import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";

:root {
  --cta-green: #22c55e;
}

.sidebar-nav .el-menu-item.cta-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0px 0px 2px 0px;
  padding: 12px 14px;
/*   border: 1px solid rgba(34,197,94,.35);
  border-radius: 10px; */
  background: rgba(34,197,94,.10);
  line-height: 1.25;
  font-weight: 700;
  color: #eafff3;
  transition: background .2s, box-shadow .2s, transform .08s, border-color .2s;
}

.sidebar-nav .el-menu-item.cta-item > i {
  font-size: 18px;
  color: var(--cta-green);
}

.sidebar-nav .el-menu-item.cta-item .sidebar-nav__link-text {
  color: var(--cta-green);
}

.sidebar-nav .el-menu-item.cta-item:hover {
  background: rgba(34,197,94,.18);
  border-color: rgba(34,197,94,.6);
  box-shadow: 0 0 0 1px rgba(34,197,94,.35) inset;
}

.sidebar-nav .el-menu-item.cta-item:active {
  transform: translateY(1px);
}

.sidebar-nav .el-menu-item.cta-item.is-active {
  background: rgba(34,197,94,.22);
  border-color: rgba(34,197,94,.65);
}

</style>

